import { Button, Flex, Grid } from "antd";
import { useNavigate } from "react-router";

export default function CardFooterAction({ route, onClick, loading, disabled, hideSubmit }){

  const navigate = useNavigate()

  const breakpoint = Grid.useBreakpoint()

  return (
    <Flex justify="end" style={{ paddingRight: 24, paddingLeft: 24 }} gap={16} >
      <Button disabled={disabled} loading={loading} block={!breakpoint.md} onClick={() => navigate(route)} variant="outlined" color="primary" >
        Batal
      </Button>
      {!hideSubmit && (
        <Button 
          variant="solid" 
          color="primary" 
          onClick={onClick}
          block={!breakpoint.md}
          loading={loading}
          disabled={disabled}
        >
          Simpan
        </Button>
      )}
    </Flex>
  )
}